App.factory('wireTransferService', ['Config', 'baseService', function(Config, baseService) {
    function WireTransferService() {
        this.getPayments = function (params) {
            return baseService.post(Config.API_URL + "/wireTransfer", params).then(
                function (success) {
                    return success;
                }, function (error) {
                    return error;
            });
        }
    }

    return new WireTransferService();
}]);